var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseSq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.5,
    y: 59.5,
    width: 59,
    height: 59,
    transform: "rotate(-180 59.5 59.5)",
    fill: "#D84727",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0003 19.0003C21.7444 19.0003 21.4882 19.0977 21.2933 19.2933L19.2933 21.2933C18.9022 21.6843 18.9022 22.3173 19.2933 22.7073L26.5862 30.0003L19.2933 37.2932C18.9022 37.6842 18.9022 38.3173 19.2933 38.7073L21.2933 40.7073C21.6843 41.0983 22.3173 41.0983 22.7073 40.7073L30.0003 33.4143L37.2932 40.7073C37.6832 41.0983 38.3173 41.0983 38.7073 40.7073L40.7073 38.7073C41.0983 38.3163 41.0983 37.6832 40.7073 37.2932L33.4143 30.0003L40.7073 22.7073C41.0983 22.3173 41.0983 21.6833 40.7073 21.2933L38.7073 19.2933C38.3163 18.9022 37.6832 18.9022 37.2932 19.2933L30.0003 26.5862L22.7073 19.2933C22.5118 19.0977 22.2562 19.0003 22.0003 19.0003Z",
    fill: "#FFFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSq);
export default __webpack_public_path__ + "static/media/close_sq.9b28f0f148dc433b390baf4070b5e9b1.svg";
export { ForwardRef as ReactComponent };